import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tabs } from '@treezor/design-system';

import { useAppDispatch } from '@/hooks/redux-helpers';
import { fetchOnboardingUsers } from '@/store/actions/onboarding-user.action';
import { OnboardingUsersTab } from '@/pages/admin/onboarding/OnboardingUsersTab';
import { TOnboardingUserType } from '@/store/models/onboarding-user.model';
import { ITab } from '@/store/models/profile.model';
import { Page } from '@/ui-kit/templates/Page';

export const OnboardingUsersPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [currentTab, setCurrentTab] = useState('incompleted');

  useEffect(() => {
    dispatch(fetchOnboardingUsers({ type: currentTab as TOnboardingUserType }));
  }, [currentTab, dispatch]);

  const tabs: ITab[] = [
    {
      id: 'incompleted',
      label: t('pages.administration.onBoarding.tabs.incomplete'),
      element: <OnboardingUsersTab type="incompleted" />,
    },
    {
      id: 'completed',
      label: t('pages.administration.onBoarding.tabs.complete'),
      element: <OnboardingUsersTab type="completed" />,
    },
  ];

  return (
    <Page>
      <Tabs
        items={tabs}
        size="s"
        onTabChanged={(index) => setCurrentTab(index === 0 ? 'incompleted' : 'completed')}
        currentTabIndex={currentTab === 'incompleted' ? 0 : 1}
      />
    </Page>
  );
};
